/**
 * @typedef {object} CountryConfig
 * @property {string} text
 * @property {string} value
 */

/** @type {CountryConfig[]} */
export default [
    {value: "AF", text: "افغانستان"},
    {value: "AX", text: "Åland"},
    {
        value: "AL",
        text: "Shqipëria",
    },
    {value: "DZ", text: "الجزائر"},
    {value: "AS", text: "American Samoa"},
    {
        value: "AD",
        text: "Andorra",
    },
    {value: "AO", text: "Angola"},
    {value: "AI", text: "Anguilla"},
    {
        value: "AQ",
        text: "Antarctica",
    },
    {value: "AG", text: "Antigua and Barbuda"},
    {value: "AR", text: "Argentina"},
    {
        value: "AM",
        text: "Հայաստան",
    },
    {value: "AW", text: "Aruba"},
    {value: "AU", text: "Australia"},
    {
        value: "AT",
        text: "Österreich",
    },
    {value: "AZ", text: "Azərbaycan"},
    {value: "BS", text: "Bahamas"},
    {
        value: "BH",
        text: "‏البحرين",
    },
    {value: "BD", text: "Bangladesh"},
    {value: "BB", text: "Barbados"},
    {
        value: "BY",
        text: "Белару́сь",
    },
    {value: "BE", text: "België"},
    {value: "BZ", text: "Belize"},
    {
        value: "BJ",
        text: "Bénin",
    },
    {value: "BM", text: "Bermuda"},
    {value: "BT", text: "ʼbrug-yul"},
    {
        value: "BO",
        text: "Bolivia",
    },
    {value: "BQ", text: "Bonaire"},
    {value: "BA", text: "Bosna i Hercegovina"},
    {
        value: "BW",
        text: "Botswana",
    },
    {value: "BV", text: "Bouvetøya"},
    {value: "BR", text: "Brasil"},
    {
        value: "IO",
        text: "British Indian Ocean Territory",
    },
    {value: "UM", text: "United States Minor Outlying Islands"},
    {
        value: "VG",
        text: "British Virgin Islands",
    },
    {value: "VI", text: "Virgin Islands of the United States"},
    {
        value: "BN",
        text: "Negara Brunei Darussalam",
    },
    {value: "BG", text: "България"},
    {value: "BF", text: "Burkina Faso"},
    {
        value: "BI",
        text: "Burundi",
    },
    {value: "KH", text: "Kâmpŭchéa"},
    {value: "CM", text: "Cameroon"},
    {
        value: "CA",
        text: "Canada",
    },
    {value: "CV", text: "Cabo Verde"},
    {value: "KY", text: "Cayman Islands"},
    {
        value: "CF",
        text: "Ködörösêse tî Bêafrîka",
    },
    {value: "TD", text: "Tchad"},
    {value: "CL", text: "Chile"},
    {value: "CN", text: "中国"},
    {
        value: "CX",
        text: "Christmas Island",
    },
    {value: "CC", text: "Cocos (Keeling) Islands"},
    {value: "CO", text: "Colombia"},
    {
        value: "KM",
        text: "Komori",
    },
    {value: "CG", text: "République du Congo"},
    {
        value: "CD",
        text: "République démocratique du Congo",
    },
    {value: "CK", text: "Cook Islands"},
    {value: "CR", text: "Costa Rica"},
    {
        value: "HR",
        text: "Hrvatska",
    },
    {value: "CU", text: "Cuba"},
    {value: "CW", text: "Curaçao"},
    {
        value: "CY",
        text: "Κύπρος",
    },
    {value: "CZ", text: "Česká republika"},
    {value: "DK", text: "Danmark"},
    {
        value: "DJ",
        text: "Djibouti",
    },
    {value: "DM", text: "Dominica"},
    {value: "DO", text: "República Dominicana"},
    {
        value: "EC",
        text: "Ecuador",
    },
    {value: "EG", text: "مصر‎"},
    {value: "SV", text: "El Salvador"},
    {
        value: "GQ",
        text: "Guinea Ecuatorial",
    },
    {value: "ER", text: "ኤርትራ"},
    {value: "EE", text: "Eesti"},
    {value: "ET", text: "ኢትዮጵያ"},
    {
        value: "FK",
        text: "Falkland Islands",
    },
    {value: "FO", text: "Føroyar"},
    {value: "FJ", text: "Fiji"},
    {
        value: "FI",
        text: "Suomi",
    },
    {value: "FR", text: "France"},
    {value: "GF", text: "Guyane française"},
    {
        value: "PF",
        text: "Polynésie française",
    },
    {value: "TF", text: "Territoire des Terres australes et antarctiques françaises"},
    {
        value: "GA",
        text: "Gabon",
    },
    {value: "GM", text: "Gambia"},
    {value: "GE", text: "საქართველო"},
    {
        value: "DE",
        text: "Deutschland",
    },
    {value: "GH", text: "Ghana"},
    {value: "GI", text: "Gibraltar"},
    {
        value: "GR",
        text: "Ελλάδα",
    },
    {value: "GL", text: "Kalaallit Nunaat"},
    {value: "GD", text: "Grenada"},
    {
        value: "GP",
        text: "Guadeloupe",
    },
    {value: "GU", text: "Guam"},
    {value: "GT", text: "Guatemala"},
    {
        value: "GG",
        text: "Guernsey",
    },
    {value: "GN", text: "Guinée"},
    {value: "GW", text: "Guiné-Bissau"},
    {
        value: "GY",
        text: "Guyana",
    },
    {value: "HT", text: "Haïti"},
    {value: "HM", text: "Heard Island and McDonald Islands"},
    {
        value: "VA",
        text: "Sancta Sedes",
    },
    {value: "HN", text: "Honduras"},
    {value: "HK", text: "香港"},
    {
        value: "HU",
        text: "Magyarország",
    },
    {value: "IS", text: "Ísland"},
    //{value: "IN", text: "भारत"},
    {value: "IN", text: "India"},
    {
        value: "ID",
        text: "Indonesia",
    },
    {value: "CI", text: "Côte d'Ivoire"},
    {value: "IR", text: "ایران"},
    {
        value: "IQ",
        text: "العراق",
    },
    {value: "IE", text: "Ireland"},
    {value: "IM", text: "Isle of Man"},
    {
        value: "IL",
        text: "יִשְׂרָאֵל",
    },
    {value: "IT", text: "Italia"},
    {value: "JM", text: "Jamaica"},
    {value: "JP", text: "日本"},
    {
        value: "JE",
        text: "Jersey",
    },
    {value: "JO", text: "الأردن"},
    {value: "KZ", text: "Қазақстан"},
    {
        value: "KE",
        text: "Kenya",
    },
    {value: "KI", text: "Kiribati"},
    {value: "KW", text: "الكويت"},
    {
        value: "KG",
        text: "Кыргызстан",
    },
    {value: "LA", text: "ສປປລາວ"},
    {value: "LV", text: "Latvija"},
    {
        value: "LB",
        text: "لبنان",
    },
    {value: "LS", text: "Lesotho"},
    {value: "LR", text: "Liberia"},
    {
        value: "LY",
        text: "‏ليبيا",
    },
    {value: "LI", text: "Liechtenstein"},
    {value: "LT", text: "Lietuva"},
    {
        value: "LU",
        text: "Luxembourg",
    },
    {value: "MO", text: "澳門"},
    {value: "MK", text: "Македонија"},
    {
        value: "MG",
        text: "Madagasikara",
    },
    {value: "MW", text: "Malawi"},
    {value: "MY", text: "Malaysia"},
    {
        value: "MV",
        text: "Maldives",
    },
    {value: "ML", text: "Mali"},
    {value: "MT", text: "Malta"},
    {value: "MH", text: "M̧ajeļ"},
    {
        value: "MQ",
        text: "Martinique",
    },
    {value: "MR", text: "موريتانيا"},
    {value: "MU", text: "Maurice"},
    {
        value: "YT",
        text: "Mayotte",
    },
    {value: "MX", text: "México"},
    {value: "FM", text: "Micronesia"},
    {value: "MC", text: "Monaco"},
    {value: "MN", text: "Монгол улс"},
    {
        value: "ME",
        text: "Црна Гора",
    },
    {value: "MS", text: "Montserrat"},
    {value: "MA", text: "المغرب"},
    {
        value: "MZ",
        text: "Moçambique",
    },
    {value: "MM", text: "Myanma"},
    {value: "NA", text: "Namibia"},
    {
        value: "NR",
        text: "Nauru",
    },
    {value: "NP", text: "नेपाल"},
    {value: "NL", text: "Nederland"},
    {
        value: "NC",
        text: "Nouvelle-Calédonie",
    },
    {value: "NZ", text: "New Zealand"},
    {value: "NI", text: "Nicaragua"},
    {
        value: "NE",
        text: "Niger",
    },
    {value: "NG", text: "Nigeria"},
    {value: "NU", text: "Niuē"},
    {
        value: "NF",
        text: "Norfolk Island",
    },
    {value: "KP", text: "북한"},
    {value: "MP", text: "Northern Mariana Islands"},
    {
        value: "NO",
        text: "Norge",
    },
    {value: "OM", text: "عمان"},
    {value: "PK", text: "Pakistan"},
    {
        value: "PW",
        text: "Palau",
    },
    {value: "PS", text: "فلسطين"},
    {value: "PA", text: "Panamá"},
    {
        value: "PG",
        text: "Papua Niugini",
    },
    {value: "PY", text: "Paraguay"},
    {value: "PE", text: "Perú"},
    {
        value: "PH",
        text: "Pilipinas",
    },
    {value: "PN", text: "Pitcairn Islands"},
    {value: "PL", text: "Polska"},
    {
        value: "PT",
        text: "Portugal",
    },
    {value: "PR", text: "Puerto Rico"},
    {value: "QA", text: "قطر"},
    {
        value: "XK",
        text: "Republika e Kosovës",
    },
    {value: "RE", text: "La Réunion"},
    {value: "RO", text: "România"},
    {
        value: "RU",
        text: "Россия",
    },
    {value: "RW", text: "Rwanda"},
    {value: "BL", text: "Saint-Barthélemy"},
    {
        value: "SH",
        text: "Saint Helena",
    },
    {value: "KN", text: "Saint Kitts and Nevis"},
    {value: "LC", text: "Saint Lucia"},
    {
        value: "MF",
        text: "Saint-Martin",
    },
    {value: "PM", text: "Saint-Pierre-et-Miquelon"},
    {
        value: "VC",
        text: "Saint Vincent and the Grenadines",
    },
    {value: "WS", text: "Samoa"},
    {value: "SM", text: "San Marino"},
    {
        value: "ST",
        text: "São Tomé e Príncipe",
    },
    {value: "SA", text: "العربية السعودية"},
    {value: "SN", text: "Sénégal"},
    {
        value: "RS",
        text: "Србија",
    },
    {value: "SC", text: "Seychelles"},
    {value: "SL", text: "Sierra Leone"},
    {
        value: "SG",
        text: "Singapore",
    },
    {value: "SX", text: "Sint Maarten"},
    {value: "SK", text: "Slovensko"},
    {
        value: "SI",
        text: "Slovenija",
    },
    {value: "SB", text: "Solomon Islands"},
    {value: "SO", text: "Soomaaliya"},
    {
        value: "ZA",
        text: "South Africa",
    },
    {value: "GS", text: "South Georgia"},
    {value: "KR", text: "대한민국"},
    {
        value: "SS",
        text: "South Sudan",
    },
    {value: "ES", text: "España"},
    {value: "LK", text: "śrī laṃkāva"},
    {
        value: "SD",
        text: "السودان",
    },
    {value: "SR", text: "Suriname"},
    {value: "SJ", text: "Svalbard og Jan Mayen"},
    {
        value: "SZ",
        text: "Swaziland",
    },
    {value: "SE", text: "Sverige"},
    {value: "CH", text: "Schweiz"},
    {
        value: "SY",
        text: "سوريا",
    },
    {value: "TW", text: "臺灣"},
    {value: "TJ", text: "Тоҷикистон"},
    {
        value: "TZ",
        text: "Tanzania",
    },
    {value: "TH", text: "ประเทศไทย"},
    {value: "TL", text: "Timor-Leste"},
    {
        value: "TG",
        text: "Togo",
    },
    {value: "TK", text: "Tokelau"},
    {value: "TO", text: "Tonga"},
    {
        value: "TT",
        text: "Trinidad and Tobago",
    },
    {value: "TN", text: "تونس"},
    {value: "TR", text: "Türkiye"},
    {
        value: "TM",
        text: "Türkmenistan",
    },
    {value: "TC", text: "Turks and Caicos Islands"},
    {value: "TV", text: "Tuvalu"},
    {
        value: "UG",
        text: "Uganda",
    },
    {value: "UA", text: "Україна"},
    {value: "AE", text: "دولة الإمارات العربية المتحدة"},
    {
        value: "GB",
        text: "United Kingdom",
    },
    {value: "US", text: "United States"},
    {value: "UY", text: "Uruguay"},
    {
        value: "UZ",
        text: "O‘zbekiston",
    },
    {value: "VU", text: "Vanuatu"},
    {value: "VE", text: "Venezuela"},
    {
        value: "VN",
        text: "Việt Nam",
    },
    {value: "WF", text: "Wallis et Futuna"},
    {value: "EH", text: "الصحراء الغربية"},
    {
        value: "YE",
        text: "اليَمَن",
    },
    {value: "ZM", text: "Zambia"},
    {value: "ZW", text: "Zimbabwe"},
];
